import styled from "styled-components";

export const StepOneContainer = styled.div`
  form {
    .address-container {
      margin-top: 16px;
    }

    .input-container {
      position: relative;
      height: 90px;
    }

    .icon-container {
      position: absolute;
      right: 16px;
      top: 44px;
      transform: translateY(-50%);
      pointer-events: none;
    }

    .input-loading .icon-container {
      position: absolute;
      right: 16px;
      top: 44px;
      transform: translateY(-50%);
      z-index: 10;
    }

    .input-spinner {
      width: 16px;
      height: 16px;
      border: 2px solid #ddd;
      border-top-color: #888;
      border-radius: 50%;
      animation: spin 0.6s linear infinite;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    .loading {
      opacity: 0.5;
      pointer-events: none;
    }

  }

  @media (min-width: 768px) {
    form {
      min-height: 670px;

      .address-container {
        margin-top: 20px;
      }

      .inputs-side-by-side {
        display: flex;
        justify-content: space-between;
        gap: 20px;
      }

      .inputs-side-by-side > .input-container {
        flex: 1 1 0;
      }

      .inputs-side-by-side.number-row > .number-input {
        flex: 0 0 130px;
      }
    }
  }
`;
